import React from 'react';

import { ArrowIosRightOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseMenuItem, DeprecatedIconButton, Typography } from '@lyearn/ui';

import { classes, iconButtonStyles } from '../../styles';

const HeadingListItem = ({
  isSelected,
  heading,
  onClick,
}: {
  heading: string;
  isSelected?: boolean;
  onClick: () => void;
}) => (
  <BaseMenuItem className={classes.headingListItem}>
    <Typography color="text-text-placeholder" variant="label-caps">
      {heading}
    </Typography>
    <DeprecatedIconButton
      appearance="secondary"
      className={cn(iconButtonStyles, { 'bg-interactive-secondary': isSelected })}
      shape="square"
      variant="ghost"
      onClick={onClick}>
      <ArrowIosRightOutline />
    </DeprecatedIconButton>
  </BaseMenuItem>
);

export default HeadingListItem;
